export default {
    login: 'تسجيل الدخول',
    registration: 'تسجيل',
    order: 'طلبي',
    language: 'الصينية',
    home: 'الصفحة الأولى',
    babyToys: 'الكلمات الرئيسية',
    aboutus: 'بشأننا',
    product: 'المنتجات',
    cart: 'عربة التسوق',
    contactus: 'اتصل بنا',
    comprehensiveInquiry: 'استفسارات شاملة',
    advancedSearch: 'بحث متقدم',
    productName: 'اسم المنتج',
    priceRange: 'نطاق السعر',
    reset: 'الاستبدال',
    search: 'البحث',
    classify: 'تصنيف',
    categories: 'تصنيف المنتجات',
    close: 'أبعد',
    open: 'إجراء',
    updateTime: 'تحديث الوقت',
    startTime: 'وقت البدء',
    endTime: 'نهاية الوقت',
    confirm: 'تأكيد',
    minimumPrice: 'أدنى سعر',
    highestPrice: 'أعلى سعر',
    L: 'طويلة',
    W: 'عرضها',
    H: 'عالية',
    inputPlaceholder: 'يرجى إدخال المحتوى',
    selectPlaceholder: 'يرجى الاختيار',
    packingCapacity: 'الحاويات',
    price: 'أسعار',
    itemNo: 'رقم المصنع',
    packing: 'طريقة التعبئة',
    productSize: 'مواصفات المنتج',
    packageSize: 'مواصفات التعبئة',
    cartonSize: 'مواصفات الصندوق الخارجي',
    innerBoxAndOuterPacking: 'حجم الصناديق الداخلية/الخارجية',
    OuterPacking: "حجم الصناديق الخارجية",
    CBMAndCUFT: 'الحجم/الحجم',
    CUFT: 'CaiJi',
    CBM: 'الحجم',
    GWAndNW: 'الوزن الإجمالي/الصافي',
    mOQ: 'قم بالحجز',
    productInformation: 'معلومات المنتج',
    relatedProducts: 'المنتجات ذات الصلة',
    more: 'المزيد',
    clear: 'إفراغ',
    inputPassword: 'يرجى إدخال كلمة المرور',
    passwordLength: 'لا يمكن أن يكون طول كلمة المرور أقل من 6 كلمات',
    inputUserName: 'يرجى إدخال الاسم',
    inputUserAccount: 'يرجى إدخال اسم المستخدم',
    inputVaildeCode: 'يرجى إدخال رمز التحقق',
    inputMobile: 'يرجى إدخال رقم الهاتف المحمول',
    inputEmail: 'يرجى إدخال صندوق البريد',
    inputEmailRules: 'شكل صندوق البريد غير صحيح',
    password: 'كلمة المرور',
    username: 'أسماء',
    vaildecode: 'رمز التحقق',
    gender: 'نوع الجنس',
    useraccount: 'اسم المستخدم',
    man: 'الرجال',
    woman: 'النساء',
    mobile: 'رقم الهاتف',
    email: 'صندوق البريد',
    address: 'عنوان الاتصال',
    CodeError: 'خطأ تشفير التحقق',
    resUserError: 'اسم المستخدم موجود بالفعل',
    notreviewed: 'لم يتم مراجعة الحسابات',
    loginError: 'رقم الحساب أو إدخال كلمة المرور',
    loginSuccess: 'الهبوط',
    regSuccess: 'التسجيل ناجح',
    deleteSuccess: 'حذف بنجاح',
    toregister: 'لا يوجد حساب؟ التسجيل',
    toLogin: 'هل لديك حساب؟ الهبوط',
    logout: 'الانسحاب',
    myShoppingCart: 'عربة التسوق الخاصة بي',
    ID: 'رقم تسلسلي',
    picture: 'الصورة',
    ItemNO: 'رقم',
    name: 'اسم',
    total: 'مجموع',
    delete: 'حذف',
    CTNS: 'صندوق عدة',
    checkAll: 'تحديد الكل',
    checkSelect: 'اختر مفتاحا إضافيا في هذه الصفحة',
    page: 'صفحة',
    goTO: 'إلى',
    totalRecords: 'المبلغ الإجمالي',
    totalCTNS: 'حجم الصندوق',
    totalQuantity: 'المجموع',
    totalPrice: 'إجمالي',
    submit: 'تقديم',
    orderDetails: 'تفاصيل الطلب',
    OrderInformation: 'معلومات الطلب',
    number: 'رقم لوحده',
    orderTime: 'وقت الطلب',
    linkman: 'الاتصال',
    remark: 'ملحوظة رقم',
    viewDetails: 'تحقق من التفاصيل',
    companyContact: 'الاتصال',
    companyTel: 'الهاتف',
    companyFax: 'الفاكس',
    companyMail: 'صندوق البريد',
    companyAddress: 'العنوان',
    productCenter: 'مركز المنتجات',
    helpCenter: 'مركز المساعدة',
    member: 'مركز الأعضاء',
    productdemand: 'الطلب على المنتج',
    newproduct: 'أحدث منتج',
    registerhelp: 'تسجيل المساعدة',
    orderhelp: 'طلب المساعدة',
    newproducts: 'عرض جديد',
    highRec: 'المنتجات الموصى بها',
    slogan: 'المنتج الأكثر مبيعا وأسرع وأفضل تغذية مرتدة في عام 2025.',
    viewmore: 'انظر المزيد',
    videocenter: 'مركز الفيديو',
    videoSlogan: 'لنعرف المزيد عن صناعة الألعاب',
    searchPicture: 'الشكل فتش',
    choosePicture: 'اختر الصورة',
    clickOrDrag: 'انقر/اسحب الملف إلى هنا',
    copyPicture: 'انسخ الصورة: انقر هنا لللصق/CTRL + V.',
    pictureCrop: 'قطع الصورة المنطقة',
    cancel: 'إلغاء',
    confirm: 'تحديد',
    pleaseLogin: 'يرجى تسجيل الدخول',
    addCart: "أضف عربة التسوق",
    delCart: "إلغاء الطلب الإضافي",
    viewPrice: 'تحقق من السعر',
    noData: 'عدد لا يحصى من الوثائق',
    systemTip: 'نصائح النظام',
    deleteData: 'هل تُحذف هذه المادة؟',
    clearCartData: 'هل تفرغ كل عربة التسوق؟',
    orderSuccess: 'تم إنشاء النظام!',
    submitTip: 'تأكيد تقديم الطلبات؟',
    noLogin: 'إضافة عربة التسوق، يرجى الهبوط',
    notImage: 'اللصق ليس صورة',
    noSelect: 'يرجى اختيار البيانات',
    hotSaleProduct: 'مبيعات ساخنة',
    popularRecommendation: 'توصية ساخنة',
    please_contact_us: 'إذا كان لديك أي أسئلة، يرجى الفاكس أو الاتصال في أي وقت',
    ock_email: 'صندوق البريد',
    contactUs: 'اتصل بنا',
    hotLine: 'الخط الساخن',
    companyAddres: 'عنوان الشركة',
    workingHours: 'ساعات العمل',
    week: 'الاثنين إلى الجمعة',
    companyInfo: 'وصف الشركة',
    noName: 'لا يوجد مترجم',
    serviceHotine: "24/7 الخط الساخن",
    success: "أضف النجاح",
    del: "حذف بنجاح",
    orderStatus: 'حالة الطلب',
    sendDate: 'تاريخ الشحن',
    expressNumber: 'رقم البريد السريع',
    unshipped: 'غير مرسل',
    shipped: 'تم شحنها',
    Disclaimer: "إبراء الذمة: جميع الصور والمنتجات في هذا الموقع تأتي من جهات التصنيع، وتملك حقوق التأليف والنشر.",
    Technic: 'الدعم التقني',
    Software: 'شركة هونسو المحدودة لتطوير تكنولوجيا البرامجيات في شينتشن',
    coNuNum: "رقم الشركة",
    faNum: "رقم المصنع",
    all: 'كل تصنيف',
    userAddress: 'عنوان التسليم',
    consignee: 'المرسل إليه',
    addressDetail: 'عنوان مفصل',
    addressinformation: 'معلومات عنوان الاستلام',
    defaultAddress: 'افتراضي',
    defaultSettings: 'افتراضي',
    edit: 'تحرير العنوان',
    add: 'عنوان جديد',
    AddinganAddress: 'عنوان جديد',
    Edittheaddress: 'تحرير العنوان',
    Ok: 'حفظ',
    Address_Consignee: 'يرجى إدخال المرسل إليه',
    Address_Mobile: 'يرجى إدخال رقم الهاتف المحمول',
    Address_Address: 'يرجى إدخال العنوان',
    PleaseContact: 'يرجى إدخال الاتصال',
    Video_playback: 'تشغيل الفيديو',
}
